"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyRepairFields = void 0;
var utils_1 = require("@hobt/utils");
var property_repair_fields_1 = require("./property-repair-fields");
exports.PropertyRepairFields = Object.values(property_repair_fields_1.PropertyRepairFieldName);
var PropertyRepairFieldsKey = utils_1.reduce(exports.PropertyRepairFields);
